import type { IZaiBackgroundNotificationViewProps } from './zai-background-notification.types'
import { ZaiBackgroundNotificationView } from './zai-background-notification.view'

export const createZaiBackgroundNotificationContent = (props: IZaiBackgroundNotificationViewProps) => (
  <ZaiBackgroundNotificationView {...props} />
)
